import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { AlignValue } from '@core/prosemirror-legacy';
import {
  DropdownComponent,
  DropdownWidth,
  GroupComponent,
  IconButtonComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-text-align-menu',
  imports: [DropdownComponent, GroupComponent, IconButtonComponent, RtTooltip, TranslatePipe],
  templateUrl: './align-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './align-menu.component.less',
})
export class AlignMenuComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public select: (val: AlignValue) => void;
  public close: () => void;
  public getActive: () => AlignValue;
}
